import { Functionality, Scalars, SiteType } from "types/graphql";
import { ID_EMPTY } from "Utils/constants";
import React from "react";
import { MeQuery } from "Apollo/Queries/UserQueries/index.generated";

export {
    ActiveNorreUserContext,
    deleteActiveNorreUserStorage,
} from "Entity/ActiveUser/NorreUser";

export const ACTIVE_AUTH_USER_STORAGE_KEY = "__active_auth_user";

export const deleteActiveUserStorage = () => {
    localStorage.removeItem(ACTIVE_AUTH_USER_STORAGE_KEY);
};

export const getActiveOrganizationName = (
    functionality: Functionality,
    customerId: Scalars["ID"]["input"] | null,
    companyId: Scalars["ID"]["input"] | null,
): string => {
    if (companyId !== ID_EMPTY && companyId !== null) {
        const company = functionality.companies.find((c) => c.id === companyId);
        return company ? company.name : "";
    } else if (customerId !== ID_EMPTY && customerId !== null) {
        const customer = functionality.customers.find(
            (c) => c.id === customerId,
        );
        return customer ? customer.name : "";
    } else {
        return "";
    }
};

export interface SetActiveAuthUserProp {
    setActiveAuthUser: (value: MeQuery["me"] | null) => void;
}

export interface ActiveAuthUserProp {
    activeAuthUser: MeQuery["me"] | null;
}

const INITIAL_VALUE: MeQuery["me"] = {
    uuid: ID_EMPTY,
    email: "",
    firstName: "",
    lastLogin: null,
    lastName: "",
    primarySite: SiteType.MainBackend,
};

export const ActiveAuthUserContext = React.createContext({
    activeAuthUser: INITIAL_VALUE,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    setActiveAuthUser: (value: MeQuery["me"] | null) => {},
});
